/**
 * Whether the browser held a session when the page loaded. `index.tsx` captures it before React
 * renders, so a sign-up or a sign-in during this visit does not change it. The What's new rules
 * use it to tell a fresh browser from an upgrade (spec 2026-10-20 What's new §7, web).
 */
let sessionAtBoot: boolean | null = null;

function hasStoredSession(): boolean {
  try {
    return window.localStorage.getItem('userToken') !== null;
  } catch {
    return false;
  }
}

/** Reads the stored session once. A second call keeps the first value. */
export function captureSessionAtBoot(): void {
  if (sessionAtBoot === null) {
    sessionAtBoot = hasStoredSession();
  }
}

export function hadSessionAtBoot(): boolean {
  return sessionAtBoot ?? false;
}

/** For tests only. */
export function setSessionAtBootForTests(value: boolean | null): void {
  sessionAtBoot = value;
}
